import { signal, type WritableSignal } from '@angular/core';
import { Router } from '@angular/router';

import { NetworkSwitchOutcome, WalletNetworkSwitchService } from './wallet-network-switch.service';

export class VaultNetworkSwitchPrompt {
  #isReconcilingNetwork = false;

  readonly dialogOpen: WritableSignal<boolean> = signal(false);

  constructor(
    private readonly cancelRoute: readonly string[],
    private readonly router: Router,
    private readonly networkSwitch: WalletNetworkSwitchService,
  ) {}

  reconcile(vaultChainId: number | undefined, walletChainId: number | null | undefined): void {
    if (vaultChainId === undefined || walletChainId === null || walletChainId === undefined) {
      this.dialogOpen.set(false);

      return;
    }

    if (vaultChainId === walletChainId) {
      this.dialogOpen.set(false);

      return;
    }

    if (this.dialogOpen() || this.#isReconcilingNetwork) {
      return;
    }

    this.dialogOpen.set(true);
  }

  confirm(vaultChainId: number | undefined): void {
    this.dialogOpen.set(false);

    if (vaultChainId === undefined) {
      return;
    }

    void this.#reconcileNetwork(vaultChainId);
  }

  cancel(): void {
    this.dialogOpen.set(false);
    void this.router.navigate([...this.cancelRoute]);
  }

  async #reconcileNetwork(vaultChainId: number): Promise<void> {
    if (this.#isReconcilingNetwork) {
      return;
    }

    this.#isReconcilingNetwork = true;

    try {
      const outcome = await this.networkSwitch.ensureVaultNetwork(vaultChainId);

      if (outcome === NetworkSwitchOutcome.Declined) {
        await this.router.navigate([...this.cancelRoute]);
      }
    } finally {
      this.#isReconcilingNetwork = false;
    }
  }
}
